import { PRODUCTS_SERVICE } from "@/services/products.service.js";

const state = {getProductsOutput: {}, postProductOutput: false, putProductOutput: false, getProductByIdOutput: {}, deleteProductByIdOutput: false, getProductBySlugOutput: {}, putProductChangeStatusOutput: false, putProductShowOnActiveBrandsProOutput: false, getProductsRelatedBySlugOutput: {}};

const actions = {
    //Service to get products
    getProducts({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsRequest');

        PRODUCTS_SERVICE.getProducts(queryParams)
            .then(
                output => {
                    commit('getProductsSuccess', output);
                },
                error => {
                    commit('getProductsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create products
    postProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postProductRequest');

        PRODUCTS_SERVICE.postProduct(input)
            .then(
                output => {
                    commit('postProductSuccess', output);
                },
                error => {
                    commit('postProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update products
    putProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductRequest');

        PRODUCTS_SERVICE.putProduct(input)
            .then(
                output => {
                    commit('putProductSuccess', output);
                },
                error => {
                    commit('putProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get product details by id
    getProductById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductByIdRequest');

        PRODUCTS_SERVICE.getProductById(id)
            .then(
                output => {
                    commit('getProductByIdSuccess', output);
                },
                error => {
                    commit('getProductByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete products
    deleteProductById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteProductByIdRequest');

        PRODUCTS_SERVICE.deleteProductById(id)
            .then(
                output => {
                    commit('deleteProductByIdSuccess', output);
                },
                error => {
                    commit('deleteProductByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get product details
    getProductBySlug({ dispatch, commit }, slug) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductBySlugRequest');

        PRODUCTS_SERVICE.getProductBySlug(slug)
            .then(
                output => {
                    commit('getProductBySlugSuccess', output);
                },
                error => {
                    commit('getProductBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update products
    putProductChangeStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductChangeStatusRequest');

        PRODUCTS_SERVICE.putProductChangeStatus(input)
            .then(
                output => {
                    commit('putProductChangeStatusSuccess', output);
                },
                error => {
                    commit('putProductChangeStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to toggle product visibility on activebrands.pro
    putProductShowOnActiveBrandsPro({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductShowOnActiveBrandsProRequest');

        PRODUCTS_SERVICE.putProductShowOnActiveBrandsPro(input)
            .then(
                output => {
                    commit('putProductShowOnActiveBrandsProSuccess', output);
                },
                error => {
                    commit('putProductShowOnActiveBrandsProFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get related products
    getProductsRelatedBySlug({ dispatch, commit }, slug) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsRelatedBySlugRequest');

        PRODUCTS_SERVICE.getProductsRelatedBySlug(slug)
            .then(
                output => {
                    commit('getProductsRelatedBySlugSuccess', output);
                },
                error => {
                    commit('getProductsRelatedBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getProducts
    getProductsRequest(state) {
    },
    getProductsSuccess(state, output) {
        state.getProductsOutput = output;
    },
    getProductsFailure(state) {
        state.getProductsOutput = false;
    },

    //postProduct
    postProductRequest(state) {
        state.postProductOutput = null;
    },
    postProductSuccess(state, output) {
        state.postProductOutput = true;
    },
    postProductFailure(state) {
        state.postProductOutput = false;
    },

    //putProduct
    putProductRequest(state) {
        state.putProductOutput = null;
    },
    putProductSuccess(state, output) {
        state.putProductOutput = true;
    },
    putProductFailure(state) {
        state.putProductOutput = false;
    },

    //getProductById
    getProductByIdRequest(state) {
    },
    getProductByIdSuccess(state, output) {
        state.getProductByIdOutput = output;
    },
    getProductByIdFailure(state) {
        state.getProductByIdOutput = false;
    },

    //deleteProductById
    deleteProductByIdRequest(state) {
        state.deleteProductByIdOutput = null;
    },
    deleteProductByIdSuccess(state, output) {
        state.deleteProductByIdOutput = true;
    },
    deleteProductByIdFailure(state) {
        state.deleteProductByIdOutput = false;
    },

    //getProductBySlug
    getProductBySlugRequest(state) {
    },
    getProductBySlugSuccess(state, output) {
        state.getProductBySlugOutput = output;
    },
    getProductBySlugFailure(state) {
        state.getProductBySlugOutput = false;
    },

    //putProductChangeStatus
    putProductChangeStatusRequest(state) {
        state.putProductChangeStatusOutput = null;
    },
    putProductChangeStatusSuccess(state, output) {
        state.putProductChangeStatusOutput = true;
    },
    putProductChangeStatusFailure(state) {
        state.putProductChangeStatusOutput = false;
    },

    //putProductShowOnActiveBrandsPro
    putProductShowOnActiveBrandsProRequest(state) {
        state.putProductShowOnActiveBrandsProOutput = null;
    },
    putProductShowOnActiveBrandsProSuccess(state, output) {
        state.putProductShowOnActiveBrandsProOutput = true;
    },
    putProductShowOnActiveBrandsProFailure(state) {
        state.putProductShowOnActiveBrandsProOutput = false;
    },

    //getProductsRelatedBySlug
    getProductsRelatedBySlugRequest(state) {
    },
    getProductsRelatedBySlugSuccess(state, output) {
        state.getProductsRelatedBySlugOutput = output;
    },
    getProductsRelatedBySlugFailure(state) {
        state.getProductsRelatedBySlugOutput = false;
    },
};

export const products = {
    namespaced: true,
    state,
    actions,
    mutations
};